var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.421659 5.40904H5.67158C5.77315 5.40904 5.86107 5.3551 5.93526 5.24713C6.0094 5.13919 6.04663 5.01137 6.04663 4.86363C6.04663 4.7159 6.00942 4.58814 5.93526 4.48005L3.31028 0.661911C3.23611 0.55409 3.14826 0.5 3.04663 0.5C2.945 0.5 2.85715 0.55409 2.78292 0.661911L0.157945 4.48005C0.083715 4.58802 0.0466309 4.7159 0.0466309 4.86363C0.0466309 5.01134 0.083715 5.13919 0.157945 5.24713C0.232257 5.3551 0.320114 5.40904 0.421659 5.40904Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67158 7.59106H0.421659C0.320032 7.59106 0.232175 7.64504 0.157945 7.75289C0.083715 7.86086 0.0466309 7.98865 0.0466309 8.13638C0.0466309 8.28411 0.083715 8.41199 0.157945 8.51991L2.78292 12.338C2.85723 12.446 2.94509 12.5 3.04663 12.5C3.14818 12.5 3.23611 12.446 3.31028 12.338L5.93526 8.51988C6.0094 8.41199 6.04663 8.28411 6.04663 8.13635C6.04663 7.98865 6.00942 7.86086 5.93526 7.75286C5.86109 7.64492 5.77315 7.59106 5.67158 7.59106Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.fa16a27e60e571bebcfa06bcb127a1ac.svg";
export { ForwardRef as ReactComponent };